import ut_austin from "../assets/logos/images/UT_Austin.png"
import longhorn_racing from "../assets/logos/images/LHR_logo.png"
import harmonic_bionics from "../assets/logos/images/Harmonic_Bionics.png"
import ansys from "../assets/logos/images/ANSYS_logo.png"
import tesla from "../assets/logos/images/Tesla_Logo.png"
import Modal from "./Modal"
import { FaArrowDown } from "react-icons/fa";
import { CiCircleMore } from "react-icons/ci";
import React, { useState } from 'react'

const Experience = () => {

    let [popUpActive, setPopUpActive] = useState(false);

    var images = [
        ut_austin, longhorn_racing, harmonic_bionics, ansys, tesla
    ];

    let dates = [
        "Fall 2021 - Present", "Fall 2021 - Present", "Summer 2022", "Spring 2023", "Summer 2023"
    ];

    let titles = [
        "B.S. Mechanical Engineering", "Suspension Member\nSuspension Lead\nVehicle Dynamics Lead\nVehicle Modeling Member", "Mechanical Engineering Intern", "Meshing Software Intern", "Chassis Engineering Intern"
    ];

    let organizations = [
        "UT Austin", "Longhorn Racing", "Harmonic Bionics", "Ansys, Inc.", "Tesla, Inc."
    ];

    let descriptions = [
        "Description", "Description", "Description", "Description", "Description"
    ];

    var buttons = [];
    for (let i = 0; i < images.length; i++) {
        buttons.push(
            <button id={"button_" + i} className="flex justify-between h-[70px] px-5 bg-white rounded-lg overflow-hidden resize-none" onClick={() => showPopUp(i)}>
                <div id={"image_" + i} className="h-full flex flex-col justify-center"> <img src={images[i]} alt={`${i}_logo`} className="h-[60px]" /> </div>
                <div id={"more_" + i} className="h-full flex flex-col justify-center text-black text-3xl"> <CiCircleMore /> </div>
                <div id={"modal_" + i} style={{display: 'none'}}> <Modal date={dates[i]} title={titles[i]} organization={organizations[i]} description={descriptions[i]} onClose={() => hidePopUp(i)} /> </div>
            </button>
        )
    };

    function showPopUp(div_id) {
        console.log("modal_" + div_id);
        if (popUpActive == false) {
            console.log("true");
            document.getElementById("modal_" + div_id).style.display = 'flex';
            setPopUpActive(true);
        }   
    };

    function hidePopUp(div_id) {
        console.log("close_" + div_id);
        if (popUpActive == true) {
            document.getElementById("modal_" + div_id).style.display = 'none';
            setPopUpActive(false);
        }
    };

    function alert(val) {
        window.alert(val);
    }

  return (
    <div className='page-startup z-10'>
        <div className='h-[calc((100dvh-80px))] flex flex-col justify-evenly pb-10 lg:h-[calc((100dvh-80px)/2)]'>
            
            <div className='hidden justify-center title text-4xl lg:flex'>Experience</div>

            <div className="flex flex-col h-full lg:h-auto justify-evenly align-items px-14 lg:px-24 lg:flex-row lg:align-items">

                <div className='flex justify-center title text-4xl lg:hidden'>Experience</div>

                {buttons}
                
            </div>
        </div>
    </div>
  )
}

export default Experience